var React = require('react');

function Close16x16 (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Color=Black, State=Close, Size=16x16"},React.createElement("path",{"id":"Vector","d":"M3.05 3.05L8 8m0 0l4.95 4.95M8 8l4.95-4.95M8 8l-4.95 4.95","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round"})));
}

Close16x16.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Close16x16;

Close16x16.default = Close16x16;
